import { RequisicaoResponseStatus } from '@/api/generated/model';

/**
 * Rótulos da requisição de exames.
 *
 * ⚠️ O status NÃO decide se dá para editar. Quem decide é o campo `editavel`,
 * que o servidor devolve — ele já considera assinatura e cancelamento juntos.
 * Derivar `status === 'RASCUNHO'` na tela seria uma segunda regra para divergir
 * da primeira.
 */
export const STATUS = Object.values(RequisicaoResponseStatus);

export const ROTULO_STATUS: Record<string, string> = {
  RASCUNHO: 'Rascunho',
  ASSINADO: 'Assinada',
  CANCELADO: 'Cancelada',
};

export const CLASSE_STATUS: Record<string, string> = {
  RASCUNHO: '',
  ASSINADO: 'text-emerald-600 border-emerald-600/40',
  CANCELADO: 'text-destructive border-destructive/40',
};

export function formatarDataHora(iso: string): string {
  return new Date(iso).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
}
